module.exports = __webpack_public_path__ + "assets/images/ride-clean-up@2x-10492f428430e199aa4b6ce61a4922f6.png";